import { formatCurrency } from '../../../../lib/CurrencyHelpers.js';
import { minutesToDuration } from '../../../../lib/DateTime.js';
import Stepper from '../../../Stepper.jsx';
import { CheckIcon } from '@heroicons/react/24/outline/index.js';
import React from 'react';

const SelectItemButton = ({
    children,
    rightContent,
    onClick,
    quantity,
    quantityIncrement,
    onChangeQuantity,
    enableQuantity,
    isSelected,
    layout,
}) => {
    return (
        <section
            type="button"
            onClick={() => {
                if (!isSelected || !enableQuantity) {
                    onClick();
                }
            }}
            className={`choose-block ${isSelected ? 'selected-block' : ''}`}
        >
            <div
                className={`${layout === 'grid' ? '' : 'flex items-center justify-between flex-1'}`}
            >
                <div>{children}</div>
                <div
                    className={`flex items-center ${layout === 'grid' ? 'flex mt-2' : ''}`}
                >
                    <div className="text-gray-500 flex gap-x-4 mr-4">
                        {rightContent}
                    </div>

                    {isSelected && enableQuantity && (
                        <Stepper
                            value={quantity}
                            onChange={onChangeQuantity}
                            renderValue={v => {
                                return v * (quantityIncrement || 1);
                            }}
                        />
                    )}
                    {!(isSelected && enableQuantity) && (
                        <span
                            type="button"
                            className="uppercase block form-button btn-small text-sm"
                        >
                            {isSelected && (
                                <span className="flex items-center block">
                                    <CheckIcon className="w-5 h-5 mr-2" />
                                    Added
                                </span>
                            )}
                            {!isSelected && 'Add'}
                        </span>
                    )}
                </div>
            </div>
        </section>
    );
};

export default SelectItemButton;
